import { Injectable, inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { Role } from 'shared-lib';
import { canActivateAuthRole } from './auth-guard';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class RoleService {
    private keycloak = inject(Keycloak);

    async checkAccess(role: Role): Promise<boolean> {
        try {
            if (!this.keycloak.authenticated) return false;
            const roles = this.keycloak.resourceAccess?.[environment.auth.clientBackend ?? '']?.roles || [];
            return roles.includes(role);
        } catch (error) {
            console.error('Error checking role access:', error);
            return false;
        }
    }

    async getRoles(): Promise<string[]> {
        try {
            if (!this.keycloak.authenticated) return [];

            return this.keycloak.resourceAccess?.[this.keycloak.clientId ?? '']?.roles || [];
        } catch (error) {
            console.error('Error getting user roles:', error);
            return [];
        }
    }

    isAuthenticated(): boolean {
        return !!this.keycloak.authenticated;
    }
}